var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarksuccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0000610352,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#ECFDF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5994 6.51838L14.6549 6.4648C14.6973 6.43719 14.731 6.43086 14.7507 6.43001C14.7729 6.42906 14.7868 6.43411 14.7938 6.43774C14.7917 6.45591 14.7753 6.53403 14.6531 6.65895L14.6398 6.67262L14.6275 6.68727L15.0105 7.0086C14.6275 6.68727 14.6274 6.68729 14.6274 6.68734L14.6272 6.68758L14.6264 6.68851L14.6233 6.69222L14.611 6.70687L14.5631 6.76404L14.3808 6.98136L13.7281 7.75995C13.1867 8.40597 12.4616 9.27144 11.7271 10.1492C10.2657 11.8956 8.74731 13.714 8.58861 13.9212L8.57654 13.937L8.56576 13.9536C8.47616 14.0921 8.31056 14.1836 8.13555 14.1836C7.94572 14.1836 7.78964 14.0939 7.69961 13.9576L5.8317 10.9192C5.76884 10.8081 5.78955 10.6669 5.91163 10.5724C6.06258 10.4706 6.24587 10.4907 6.35058 10.5813L7.9205 12.2586L8.26744 12.6293L8.63276 12.2767L14.5994 6.51838Z",
    fill: "#12B76A",
    stroke: "#12B76A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarksuccess);
export default __webpack_public_path__ + "static/media/marksuccess.a596f6ddbe4726009138d0c31fec3e2f.svg";
export { ForwardRef as ReactComponent };